
import { Injectable } from '@angular/core';
import { BackendService } from '../../backend.service';
import { AvailableBank, SavedCard } from './juspay';
import { Observable } from 'rxjs';

@Injectable()
export class JuspayService {

  private serverGetBankListUrl = '/juspay/api/v1/order/availableBanks';
  private getSavedCardsUrl = '/juspay/api/v1/order/{customerId}/savedCards';
  private getJuspayStyleUrl = '../../assets/juspay/juspayStyle.json';

  constructor(private backendService: BackendService) { }

  getBankList(): Observable<AvailableBank[]> {
    return this.backendService.getData(this.serverGetBankListUrl);
  }
  getSavedCards(): Observable<SavedCard[]> {
    return this.backendService.getData(this.getSavedCardsUrl);
  }
  getJuspayStyle() {
    return this.backendService.getData(this.getJuspayStyleUrl, null, true);
  }

}
